export const URL_PATTERN = '((f|ht){1}(tp|tps):\\/\\/([\\w-]+\\.)+[\\w-:]+(\\/[\\w-:./?%&#=]*)?)';

export const EMOTION_PATTERN = '\\[[^\\[\\]]+\\]';

export const MENTION_MEMBER_PATTERN = '@\\(\u200b(\\{[^\u200b]+\\})\u200b\\)';

export const COMMON_LINK_PATTERN = '#\\(\u200b(\\{[^\u200b]+\\})\u200b\\)';

// / 图片正则
export const PICTURE_PATTERN = '##\\(\u200b(\\{[^\u200b]+\\})\u200b\\)';

// / 机器人命令正则
export const BOT_COMMAND_PATTERN = 'BOT\\(\u200b(\\{[^\u200b]+\\})\u200b\\)';

export interface TextNodePatternList {
  URL_PATTERN: string,
  EMOTION_PATTERN: string,
  MENTION_MEMBER_PATTERN: string,
  COMMON_LINK_PATTERN: string,
  PICTURE_PATTERN: string,
  BOT_COMMAND_PATTERN: string
}

export const textNodePatternList: TextNodePatternList = {
  URL_PATTERN,
  EMOTION_PATTERN,
  MENTION_MEMBER_PATTERN,
  COMMON_LINK_PATTERN,
  PICTURE_PATTERN,
  BOT_COMMAND_PATTERN,
};

export const matchAll = (str: string, reg: RegExp): Array<RegExpExecArray> => {
  let match;
  const tempArr = [];
  while ((match = reg.exec(str)) !== null) {
    tempArr.push(match);
  }
  return tempArr;
};
